import { render, staticRenderFns } from "./recently-used-models.html?vue&type=template&id=5e27b69a&scoped=true&external"
import script from "./recently-used-models.js?vue&type=script&lang=js&external"
export * from "./recently-used-models.js?vue&type=script&lang=js&external"
import style0 from "./recently-used-models.scss?vue&type=style&index=0&id=5e27b69a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27b69a",
  null
  
)

export default component.exports